import React, { useEffect, useState } from "react";
import { Input, Checkbox, Button, Space, Row, Col, List, Modal, Image, Alert, Tooltip } from "antd";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { PropertyHandlers } from "../state/actions";
import axios from "axios";
import { Loading } from "../../Common";
import { useMediaQuery } from "react-responsive";
import moment from "moment";
import ResureSign from "../../Assets/Icons/Resure_icon.png";
import { FileTextOutlined } from "@ant-design/icons";

const ReSureSignDocs = ({handleCancel,checkedDocs, setCheckedDocs, nestedModalOpen, setNestedModalOpen, propertyId, offerId, RTDInitiator, buyerAgentIds, sellerAgentIds, isWeb, delegate }) => {
  
  const dispatch = useDispatch();
  let { resure_Sign_Loading, resure_Sign_Docs ,importResureSignSucess} = useSelector((state) => state.PropertyReducer, shallowEqual);
  

  const isSmallScreen = useMediaQuery({ maxWidth: 480 });

  let unmounted = {
    value: false,
  };
  let source = axios.CancelToken.source();


  useEffect(() => {
    dispatch(PropertyHandlers.getResure_SignDocs());
    return () => {
      unmounted.value = true;
      source.cancel("Cancelling in cleanup");
    };
  }, []);

 

  const handleImport = () => {
    Modal.confirm({
      title: "Would you like to copy these documents to Property Docs?",

      okText: "Yes",
      cancelText: "No",
      onOk: async () => {
        const formIds = checkedDocs.map((doc) => doc._id);
        const importPayload = {
          formIds,
          ...(offerId ? { offerId } : {}),
          ...(propertyId ? { propertyId } : {}),
          RTDInitiator,
          ...(buyerAgentIds && buyerAgentIds.length > 0 ? { buyerAgentIds } : {}),
          ...(sellerAgentIds && sellerAgentIds.length > 0 ? { sellerAgentIds } : {})
        };

        await dispatch(PropertyHandlers.importRe_sure_sign_docs(importPayload));
        handleCancel();
        const params = {
          ...(offerId ? { offerId: offerId } : {}),
          ...(propertyId ? { propertyId: propertyId } : {}),
          openFor: RTDInitiator === "SELLER" ? "SELLER_AGENT" : "BUYER_AGENT",
          ...(delegate ? delegate : {}),
          section: "PROPERTY_DOCS",
          ...(isWeb ? { isWeb: true } : {}),
          queryPlatform: "WEB",
        };
        
        if ((offerId || propertyId)) {
          dispatch(PropertyHandlers.getPropertyDocsFun({ params, unmounted, source }));
        }
        // Your import logic here
      },
    });
  };

  

  const handleSingleCheck = (isChecked, doc) => {
    if (isChecked) {
      // Add full doc object if not already in checkedDocs
      setCheckedDocs((prev) => {
        const exists = prev.some((d) => d._id === doc._id);
        if (!exists) {
          return [...prev, doc];
        }
        return prev;
      });
    } else {
      // Remove the doc from checkedDocs
      setCheckedDocs((prev) => prev.filter((d) => d._id !== doc._id));
    }
  };

  const isChecked = (doc) => {
    return checkedDocs.some((d) => d._id === doc._id);
  };

  return (
    <div>
      <div style={{ width: "100%", justifyContent: "center", display: "flex", fontWeight: "bold", fontSize: isSmallScreen ? "15px" : "20px", color: "#178DFA" }}>RE-Sure Sign Docs</div>
      <div id="showMsgDiv" style={{ fontSize: "10px", fontWeight: "400", textAlign: "left" }}>
                <Alert style={{ width: "100%" }} message={" When importing documents, a new copy of the selected documents will be created. This copy will be visible under Property Documents and in RE-Sure Sign  Documents. When accessing from RE-Sure the imported file will be in PDF format. To send or edit the document, the document author must log in to their RE-Sure Sign account and perform these actions from there."} type="info" showIcon />
              </div>
      {resure_Sign_Loading ? (
        <Loading />
      ) : (
        <div  style={{
                width: "100%",
                color: "black",
                height: "350px",
                overflowY: "auto",
                marginTop:"20px",
                overflowX: "hidden",
                paddingRight: "5px",
              }}>
  <table className="licenseTable" style={{ width: "100%", borderTop: 0 }}>
    <thead style={{ position: "sticky", top: 0, zIndex: 1, background: "white" }}>
      <tr style={{ position: "sticky", top: 0, zIndex: 2 }}>
        <th style={{ width: "65%" }}>Document Name</th>
        <th style={{ width: "20%" }}>Creation Date</th>
        <th style={{ width: "15%" }}></th>
      </tr>
    </thead>
    <tbody>
      {resure_Sign_Docs?.map((doc, index) => (
        <tr key={index}>
          {/* Document Name */}
          <td style={{
            fontWeight: "bold",
            color: "grey",
            fontSize: "18px",
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
            maxWidth: "400px",
            border: "none",
          }}>
            <FileTextOutlined
              style={{
                color: "#74b3ed",
                marginRight: "5px",
                fontSize: "18px",
              }}
            />
            <Tooltip title="RE-Sure Sign Document">
            <Image
              style={{
                objectFit: "contain",
                height: "40px",
                verticalAlign: "middle",
                marginLeft: "5px",
                marginRight: "-5px",
              }}
              height={40}
              src={ResureSign}
              preview={false}
            />
            </Tooltip>
            {doc.formName}
            
          </td>

          {/* Creation Date */}
          <td style={{
            color: "black",
            fontWeight: "500",
            textAlign: "center",
            verticalAlign: "middle",
            border: "none",
          }}>
            {moment(doc.createdAt).format("MM/DD/YYYY")}<br />
            {moment(doc.createdAt).format("hh:mm A")}
          </td>

          {/* Checkbox */}
          <td style={{ textAlign: "center", verticalAlign: "middle", border: "none", }}>
            <Checkbox
              checked={isChecked(doc)}
              onChange={(e) => handleSingleCheck(e.target.checked, doc)}
            />
          </td>
        </tr>
      ))}
    </tbody>
  </table>
</div>

      )}

      {/* Buttons */}
      <div style={{ display: "flex", justifyContent: "flex-end" }}>
        <Space>
          <Button type="primary" onClick={handleImport} disabled={checkedDocs.length === 0}>
            Import
          </Button>
          <Button onClick={handleCancel}>Cancel</Button>
        </Space>
      </div>
    </div>
  );
};

export { ReSureSignDocs };
